<div class="content" *ngIf="item" style="padding: 5px; font-size: 16px">
  <div class="row">
    <div class="col-md-8">
      <div class="help-block h4">
        Item Detail {{ item.shipped ? "(Shipped)" : "" }}
        <close-button></close-button>
      </div>
      <hr />
    </div>
  </div>
  <div class="card" title="Item Detail">
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <dt>Container Number</dt>
          <dd>{{ item.containerNumber }} - {{ item.wasteType }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Item Number</dt>
          <dd>{{ item.itemNumber }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Start Date:</dt>
          <dd class="pickupDate">{{ item.pickupDate | date : "MM/dd/yyyy" }}</dd>
        </div>
        <div class="col-md-3">
          <dt>Entered by:</dt>
          <dd>{{ item.enteredBy }} - {{ item.enteredByName }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Tracking Number</dt>
          <dd>{{ item.trackingNumber }}</dd>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <dt>Owner</dt>
          <dd>{{ item.owner }} - {{ item.ownerName }} - {{ item.phone }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Organization</dt>
          <dd>{{ item.orgCode }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Building Number</dt>
          <dd>{{ item.bldgNo }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Lab Number</dt>
          <dd>{{ item.labNo }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Charge Code</dt>
          <dd>{{ item.chargeCode }}</dd>
        </div>
      </div>

      <div class="row">
        <div class="col-md-5">
          <dt>Waste Stream</dt>
          <dd>
            {{ item.streamName }}
            <span *ngIf="item.isRecycle">
              -
              {{
                item.isSolidPetrolium
                  ? "Solid Petroleum"
                  : item.isLiquidPetrolium
                  ? "Liquid Petroleum"
                  : item.isEmptyDrum
                  ? "Empty Drum"
                  : "UNKNOWN"
              }}
            </span>
          </dd>
        </div>
        <div class="col-md-5" *ngIf="item.isLabPack">
          <dt>Detail</dt>
          <dd>{{ item.itemDetail }}</dd>
        </div>
        <div class="col-md-2" *ngIf="item.isLabPack">
          <dt>RCRA</dt>
          <dd>{{ item.labPackRcra ? "Yes" : "No" }}</dd>
        </div>
      </div>

      <div class="row" *ngIf="item.isLabPack">
        <div class="col-md-12">
          <dt>Description</dt>
          <dd>{{ item.description }}</dd>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <dt>Quantity</dt>
          <dd>{{ item.numberOfItems }}</dd>
        </div>
        <div class="col-md-2" *ngIf="item.isLabPack">
          <dt>Physical State</dt>
          <dd>{{ item.physicalState }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Volume</dt>
          <dd>{{ item.volumeUn }}</dd>
        </div>
        <div class="col-md-2" *ngIf="!item.isRecycle">
          <dt>Weight</dt>
          <dd>{{ item.weightUn }}</dd>
        </div>
        <div class="col-md-2" *ngIf="item.isLabPack">
          <dt>Material</dt>
          <dd>{{ item.itemContainerMaterial }}</dd>
        </div>
        <div class="col-md-2" *ngIf="item.isLabPack">
          <dt>Spent</dt>
          <dd>{{ item.spent ? "Yes" : "No" }}</dd>
        </div>
      </div>

      <div class="row" *ngIf="item.isLabPack">
        <div class="col-md-1">&nbsp;</div>
        <div class="col-md-11">
          <dt>RCRA Codes</dt>
          <dd>{{ item.wasteCodesJoin }}</dd>
        </div>
      </div>
    </div>
  </div>
</div>
